import { createContext, useContext } from "react";

const CCmodeSettingContext = createContext({
    activeKey: "",
    setActiveKey: () => {},
    isFormChanged: false,
    setIsFormChanged: () => {},
    showFormChangePopUp: false, 
    setShowFormChangePopUp: () => {},
    nextKey: null, 
    setNextKey: () => {}
});

export function useCCmodeSettingContext() {
    return useContext(CCmodeSettingContext);
}

export default CCmodeSettingContext;
